import { render } from "./WikiTreeItemComponent.vue?vue&type=template&id=75714b21&scoped=true&ts=true"
import script from "./WikiTreeItemComponent.vue?vue&type=script&lang=ts"
export * from "./WikiTreeItemComponent.vue?vue&type=script&lang=ts"

import "./WikiTreeItemComponent.vue?vue&type=style&index=0&id=75714b21&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75714b21"]])

export default __exports__